(function() {
    'use strict';
    angular
        .module('verificadocumentoApp')
        .factory('Documento', Documento);

    Documento.$inject = ['$resource'];

    function Documento ($resource) {
        var resourceUrl =  'public/documentoelectronico/:folioControl';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dom = angular.fromJson(data.dom);
                    }
                    return data;
                }
            }
        });
    }
})();
